import React from 'react';
import { StarIcon } from 'lucide-react';
export function Stars({
  count = 5
}: {
  count?: number;
}) {
  return <div className="flex gap-0.5" aria-label={`${count} de 5 estrellas`} data-id="element-46">
      {Array.from({
      length: count
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" data-id="element-47" />)}
    </div>;
}